var map = {
	"./symbol_0.png": 72786,
	"./symbol_1.png": 87003,
	"./symbol_2.png": 8672,
	"./symbol_3.png": 63497,
	"./symbol_4.png": 63670,
	"./symbol_5.png": 59999,
	"./symbol_6.png": 5348,
	"./symbol_7.png": 45293,
	"./symbol_8.png": 45434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68821;